<template>
  <div class="overall-bg pt-0">
    <b-container>
      <b-form @submit.prevent="IsSubmit">
        <b-row class="stepperdiv">
          <b-col lg="6" md="6" sm="6" cols="2">
            <BackToMasters :goback="$router.back"></BackToMasters>
            <Headerlayout :headertext="warningmsgcontent.TitleContent === 'Raise a PR'
              ? $t('PurchaseRequest.title')
              : warningmsgcontent.TitleContent === 'Raise a PO'
                ? $t('PurchaseOrder.title')
                : ''
              " :contenttext="warningmsgcontent.TitleContent === 'Raise a PR'
                ? $t('PurchaseRequest.contents')
                : warningmsgcontent.TitleContent === 'Raise a PO'
                  ? $t('PurchaseOrder.contents')
                  : ''
                "></Headerlayout>
          </b-col>
          <b-col lg="6" md="6" sm="6" cols="2">
            <Footer :label="warningmsgcontent.SubmitButtonName" class="pb-3" :goback="$router.back"
              :loading="SaveLoader" />
            <!-- <AddButton :btnname="warningmsgcontent.SubmitButtonName" @click="IsSubmit" />
                          <cancel @canclebtn="$emit('cancel')" /> -->
          </b-col>
        </b-row>
        <FormLoader :loading="formloader" v-if="formloader" />

        <div class="row form-white-bg" v-else>
          <b-row>
            <b-row>
              <b-col lg="3" md="4" sm="6">
                <div class="field">
                  <label>{{ $t("PurchaseRequest.Code") }}</label>
                  <p>{{ ObjVal.DocNo }}</p>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col lg="3" md="4" sm="6">
                <div class="field">
                  <!-- {{ StoreDropdown.StoreId }} -->
                  <StoreDropDown :label="$t('5000.store')" name="Store" id="Store" placeholder="Select store"
                    v-model="StoreDropdown.StoreId" :filterId="StoreID" @update:modelValue="StoreOnChange('S')"
                    :rules="{ required: true }" :required-icon="true" :storetype="0" :disabled="StoreDropdownDisable"
                    :storeFilterStatus="1" />

                  <!-- Aravind eyecare -->
                  <!-- <StoreDropDown :label="$t('5000.store')" name="Store" id="Store" placeholder="Select store"
                    v-model="StoreDropdown.StoreId" :filterId="0" @update:modelValue="StoreOnChange('S')"
                    :rules="{ required: true }" :required-icon="true" :storetype="0" :disabled="StoreDropdownDisable"
                    :storeFilterStatus="1" /> -->
                </div>
              </b-col>
              <b-col lg="3" md="4" sm="6" v-if="param == 'PR' && StoreStatus == 1">
                <div class="field" v-if="requestdropdown">
                  <CustomMultiSelect :label="$t('Request.requestid')" placeholder="Select Request Id"
                    v-model="requestid.RequestIDValue" :items="requestid.RequestIDOptions" @update:modelValue="
                      RequestIDOnChange(requestid.RequestIDValue)
                      " ref="multiRef" />
                </div>
              </b-col>

              <b-col lg="6" md="4" sm="6" cols="12" class="d-flex">
                <div class="field">
                  <label>{{ $t("Request.uploadquotation") }}</label>
                  <input type="file" :multiple="true" id="actual-btn" @change="handleChangedocument" ref="fileInput"
                    style="display: none" />
                  <label id="custom-btn" for="actual-btn" class="flbtn">
                    <i class="pi pi-upload" style="color: slateblue"></i>
                    Choose File</label>
                </div>
              </b-col>
              <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
                <div class="fileuploadcard my-2" :title="item.fileName">
                  <div>
                    <p class="filenametxt">{{ item.fileName }}</p>
                    <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                      view
                    </div>
                  </div>
                  <DeleteIcon @click="fileuploadDelete(item)" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="10" md="8" sm="12" cols="12">
                <div class="field mt-3">
                  <Textarea v-model="ObjVal.Remarks" :requiredIcon="false" placeholder=" " name="Remarks" id="Remarks"
                    :label="$t('item.Remarks')" :rules="{ required: false }" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="transactiontabs">
                <TabView class="tabview-custom" ref="tabview4" v-model:activeIndex="clases.ItemsReOrderTab">
                  <TabPanel>
                    <template #header>
                      <i class="pi pi-align-left ps-3"></i>
                      <span>{{ $t("invtabs.items") }}</span>
                    </template>
                    <div>
                      <b-row>
                        <b-col class="d-flex flex-row-reverse py-3">
                          <p @click="AddButtonItem" class="add-items d-flex d-flex-row-reverse">
                            + {{ $t("btn.addnew") }}
                          </p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <b-collapse id="collapse-3" :class="displayClass" v-model="toggleshow">
                            <!-- {{ dataItems }} -->
                            <Item @additemclick="AddItems" v-model:data-items="dataItems" :show-fields="showFields"
                              :addItemData="ItemTable" :commonItemProps="commonItemProps" @calculation="TotalGrossCalc"
                              :requestdata="requestdata" @clearitem="clearItems" @ItemUpdated="ItemUpdated"
                              LasTTransactionDocType="18" />
                          </b-collapse>
                        </b-col>
                      </b-row>
                      <!-- {{ ItemTable }} -->

                      <Tableview v-if="param == 'PR'" :rowHover="true" filterDisplay="menu" :loading="loading"
                        responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields"
                        v-model:value="ItemTable">
                        <template v-slot:Add>
                          <span>
                            <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                          </span>
                        </template>
                        <template v-slot:field>
                          <span>
                            <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
                          </span>
                        </template>

                        <template v-slot:Brandmodelsize="{ data }">
                          <span>
                            <template v-if="data.BrandName">{{
                              data.BrandName
                            }}</template>
                            <template v-if="data.BrandName && data.ModelNumberName">/</template>
                            <template v-if="data.ModelNumberName">{{
                              data.ModelNumberName
                            }}</template>
                            <template v-if="
                              (data.BrandName || data.ModelNumberName) &&
                              data.SizeName
                            ">/</template>
                            <template v-if="data.SizeName">{{
                              data.SizeName
                            }}</template>
                          </span>
                        </template>
                        <template v-slot:requested="{ data }">
                          <span>
                            {{ data.ItemQuantity }}
                            <!-- {{ calculatePacksNeeded(data.ItemQuantity, data.PackSizeQty, 1) }} -->
                          </span>
                        </template>
                        <template v-slot:ratecal="{ data }">
                          <span>
                            {{ data.Rate }}
                          </span>
                        </template>
                        <template v-slot:UnitRateSlot="{ data }">
                          <span>
                            {{ data.UnitRate }}
                          </span>
                        </template>
                        <template v-slot:StockInHand="{ data }">
                          {{
                            (data.StockInHand || 0) -
                            ((data.PickedQty || 0) + (data.InTransist || 0))
                          }}
                        </template>

                        <template v-slot:PickedQty="{ data }">
                          {{ data.PickedQty || 0 }}
                        </template>

                        <template v-slot:InTransist="{ data }">
                          {{ data.InTransist || 0 }}
                        </template>

                        <template v-slot:action="{ data }">
                          <div class="d-flex align-items-center">
                            <EditIcon @click="IsItemEdit(data)" />
                            <DeleteIcon @click="ItemDeleteConfirm($event, data)" />
                            <Button @click="
                              (visible = true), getSupplierDetailsItemId(data)
                              " icon="pi pi-info-circle" class="p-button-rounded editicon p-button-text" />
                          </div>
                        </template>
                      </Tableview>
                    </div>
                  </TabPanel>

                  <TabPanel v-if="param == 'PR'">
                    <template #header>
                      <i class="pi pi-shopping-bag pe-3"></i>
                      <span>{{ $t("invtabs.itembelowreorderlevel") }}</span>
                    </template>
                    <p>
                      <AddItemsVue @AddSingleClick="AddSingleConfirmation('Single')" />
                      <!-- @SelectAll="AddAllConfirmation('All')" -->
                      <!-- {{ ReOrderData }} -->
                      <!-- <ReorderETableview :rowHover="true" filterDisplay="menu" :loading="loading"
                        responsiveLayout="scroll" :columns="ReOrderheaders" :data="ReOrderData"
                        v-model:selection="selectedProduct" :selectionMode="true"> -->

                      <ReorderETableview :rowHover="true" filterDisplay="menu" :loading="loading"
                        responsiveLayout="scroll" :columns="ReOrderheaders" :data="ReOrderData"
                        @selection="ReOrderItemSelect" :selectionMode="true" :selection="selectedProduct">
                        <template v-slot:Brandmodelsize="{ data }">
                          <p>
                            <span v-if="data.BrandName">{{ data.BrandName }} </span><span
                              v-if="data.ModelNumberName">/{{ data.ModelNumberName }} </span><span
                              v-if="data.SizeName">/{{ data.SizeName }}</span>
                          </p>
                        </template>
                      </ReorderETableview>
                    </p>
                  </TabPanel>
                </TabView>
              </b-col>
            </b-row>
          </b-row>
        </div>
      </b-form>
    </b-container>
  </div>
  <Dialog :modal="true" v-model:visible="visible" :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '65vw' }" header="Item Info" @after-hide="visible = false">
    <Tableview :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
      :columns="Iteminfoheaders" v-model:value="supplierDetailsList" :selectionMode="false">
      <template v-slot:Add>
        <span>
          <AddButton :btnname="$t('btn.plusaddnew')"></AddButton>
        </span>
      </template>
    </Tableview>
  </Dialog>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <!-- <AddItemConfirmation :Editmodel="AddItemmodel" @yes="CopyReorderData(confirmval)" @no="AddItemmodel = false"
    :content="msgcontent" /> -->
  <AddItemConfirmation :Editmodel="AddItemmodel" @yes="CopyReorderData()" @no="AddItemmodel = false"
    :content="msgcontent" />
  <WarningMessage :visible="wariningPopup" :content="warningmsgcontent.warningcontent" @ok="ClosewariningPopup()" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />

  <Toast />
  <ConfirmPopup />
</template>

<script lang="ts">
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import moment from "moment";
import BackToMasters from "../../../../../components/FormComponents/BacktoMaster.vue";
import CustomDropdown from "../../../../../components/FormComponents/Dropdown.vue";
import Headerlayout from "../../../../../components/Masters/HeaderLayout.vue";
import Badge from "primevue/badge";
import AddItemsVue from "../../../components/Transaction/AddItems.vue";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  reactive,
  watch,
} from "vue";
import { setupHistoryManagement } from "../../../Service/HistoryManage";

import PRETableview from "../../../../../components/FormComponents/EditableTable.vue";
import ReorderETableview from "../../../../../components/FormComponents/EditableTable.vue";
import Tableview from "../../../../../components/FormComponents/NormalTable.vue";

import { FilterMatchMode, FilterOperator } from "primevue/api";
import Item from "../../../components/Transaction/Item.vue";
import { useRoute, useRouter } from "vue-router";
import Footer from "../../../../../components/FormComponents/Footer.vue";
import cancel from "../../../../../components/GeneralButtons/CancelButtton.vue";
import RequestId from "../../../components/Transaction/stockwithoutaffect/RequestId.vue";
import TextField from "../../../../../components/FormComponents/TextInput.vue";
import CustomMultiSelect from "../../../../../components/FormComponents/MultiSelectDropdown.vue";
import common from "../../../Service/CommonService";
import ItemList from "../../../components/Transaction/ItemList.vue";
import WithoutStockService from "../../../Service/WithoutStockAffectService";
import CreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import POCreateSuccessully from "../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AddItemConfirmation from "../../../../../components/FormComponents/AddItemsConfirmation.vue";
import WarningMessage from "../../../../../components/FormComponents/WarningMessage.vue";
import QuoteConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import PIConfirmation from "../../../../../components/FormComponents/EditConfirmation.vue";
import StockWOFileUploadServices from "../../../Service/StockWOFileUploadService";

import StoreService from "../../../Service/StoreService";
import CrystalReportPrintPopUp from "../../../components/Print/CrystalReportPrint.vue";

import FileUpload from "primevue/fileupload";
import StoreDropDown from "../../../components/DropDown/StoreDropDown.vue";
import Table from "../../../../../components/FormComponents/Table.vue";
import Textarea from "../../../../../components/FormComponents/TextArea.vue";

import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import FormLoader from "../../../../../components/FormComponents/FormSkeletonLoader.vue";
export default defineComponent({
  components: {
    Badge,
    AddItemsVue,
    Item,
    PRETableview,
    Tableview,
    ReorderETableview,
    Footer,
    cancel,
    BackToMasters,
    Headerlayout,
    RequestId,
    TextField,
    CustomMultiSelect,
    CreateSuccessully,
    POCreateSuccessully,
    UpdatedSuccessfully,
    AddItemConfirmation,
    WarningMessage,
    CustomDropdown,
    QuoteConfirmation,
    PIConfirmation,
    CrystalReportPrintPopUp,
    StoreDropDown,
    Table,
    Textarea,
    FormLoader,
  },

  props: {
    showone: {
      type: String,
      default: "",
    },
  },

  setup(props, { emit }) {
    debugger;

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let FileObject: any = ref({
      FileName: null,
      FileUrl: null,
    });

    const toast = useToast();
    const confirm = useConfirm();

    const { handleSubmit, errors, resetForm, resetField } = useForm();

    let List = ref([]);
    let loading = ref(false);
    let SaveLoader = ref(false);
    let showitemfield = ref(false);
    const items: any = ref([]);
    const displayClass = ref("");
    let toggleshow = ref(false);
    const ItemTable: any = ref([]);
    // const dupitems: any = ref([]);
    const formloader = ref(false);
    let requestdata: any = ref();
    const ReOrderData: any = ref([]);
    const router = useRouter();
    const route = useRoute();
    const successpop = ref(false);
    const updatepop = ref(false);
    const AddItemmodel = ref(false);
    const wariningPopup = ref(false);
    const selectedProduct: any = ref([]);
    let requestdropdown = ref(true);
    let requestValue = ref(false);
    let requestidValue = ref("");
    const multiRef = ref<HTMLElement | null>(null);
    const dataItems = ref({});
    const CrystalReportPopup = ref(false);
    const AddData = ref<string[]>([]);
    let RequestId = "";
    let SavingArray: any = ref([]);
    let StoreDropdownDisable = ref(false);
    const confirmval = ref();
    const { t } = useI18n();

    let msgcontent = ref({ contentvalue: "" });
    let warningmsgcontent = ref({
      warningcontent: "",
      TitleContent: "",
      SubmitButtonName: "",
    });

    const commonItemProps = ref({
      storeId: "",
      type: 0,
      PRFlag: 1,
      BranchId: 0,
    });

    let clases = ref({
      ItemsReOrderTab: 0,
      WithAndWithoutRateTab: 0,
    });

    watch(
      () => t("btn.save"),
      (newValue) => {
        warningmsgcontent.value.SubmitButtonName = newValue;
      }
    );

    let Entitydata = ref();
    let QueryStringValue3: any = route.query;
    QueryStringValue3 = JSON.parse(QueryStringValue3.data);
    let StoreID = QueryStringValue3["StoreId"];
    let StockWoTransTMId = QueryStringValue3["StockWoTransTMId"];
    let StoreStatus = QueryStringValue3["status"];
    let IsDraftFlag = QueryStringValue3["IsDraft"];
    commonItemProps.value.storeId = QueryStringValue3["StoreId"];
    Entitydata.value = Number(QueryStringValue3.EntityId) ?? 0;
    let OperationId = Number(QueryStringValue3.OperationId) ?? 0;
    let param = route.query.param;

    let supplierDetailsList = ref([]);
    const visible: any = ref(false);

    let QueryStringValue: any = route.query;
    QueryStringValue = JSON.parse(QueryStringValue.data);

    const ParameterValues = ref({ Id: 0 });
    const PrintType = ref({ Type: "S", FormId: 41, ModuleId: 3 });

    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const day = now.getDate();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const seconds = now.getSeconds();
    const milliseconds = now.getMilliseconds();

    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}T${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds
          .toString()
          .padStart(3, "0")}Z`;

    console.log(formattedDate);

    // end
    const StoreDropdown = ref({
      StoreOptions: [],
      StoreId: ref(),
      ToStoreId: 0,
      ToStoreBrMapId: 0,
      ToStoreBranchId: 0,
      IsStoreSupplier: false,
    });

    const ObjVal = ref({
      Id: 0,
      DocType: "",
      DocNo: "",
      DocDate: formattedDate,
      StoreBrMapId: 0,
      FromStoreBranchId: 0,
      FromStoreBrMapId: 0,
      ToStoreBranchId: 0,
      ToStoreBrMapId: 0,
      Remarks: "",
      RefId: 0,
      RefNo: "",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedAt: "",
      ModifiedBy: 0,
      HospitalId: 0,
      BranchId: 0,
      SupplierId: 0,
      Amount: 0.00,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      PaymentTermsId: 0,
      DeliveryTermsId: 0,
      QuotationFileName: "",
      IsDraft: 0,
      TransportCharges: "0.00",
      OtherCharges: "0.00",
      DiscountAmount: "0.00",
      Freightcharges: "0.00",
      TaxAmount: 0.00,
      SGSTTaxAmount: 0.00,
      CGSTTaxAmount: 0.00,
      IGSTTaxAmount: 0.00,
      IsStoreSupplier: false,
      StockWODetailList: [],
    });

    const grossvalues = ref({
      grossamount: 0.0,
      taxamount: 0.0,
      totaldiscountamount: 0.0,
      transportcharges: 0.0,
      servicecharges: 0.0,
      othercharges: 0.0,
      netamount: 0.0,
      totalqty: 0.0,
    });

    const PRCalcDetails: any = ref({
      GrossAmount: 0.0,

      TaxAmount: 0.00,
      SGSTTaxAmount: 0.00,
      CGSTTaxAmount: 0.00,
      IGSTTaxAmount: 0.00,
      Transportcharges: 0.00,
      Freightcharges: 0.00,
      Othercharges: 0.00,
      DiscountAmount: 0.00,
      ItemCount: 0,

      TotalAmount: 0.00,
    });

    let showFields = {
      // Category: true,
      Name: {
        show: true,
        require: true,
      },
      Batch: {
        show: false,
        require: false,
      },
      PackSize: {
        show: true,
        require: true,
      },
      UnitRate: {
        show: true,
        require: true,
      },
      Qty: {
        show: true,
        require: true,
      },
      AvailQty: {
        show: false,
        require: false,
      },
      IssuedQty: {
        show: false,
        require: false,
      },
      RequestedQty: {
        show: false,
        require: false,
      },
      Brand: {
        show: true,
        require: false,
      },
      ModelNumber: {
        show: true,
        require: false,
      },
      Size: {
        show: true,
        require: false,
      },
      UOM: {
        show: true,
        require: true,
      },
    };

    function ShowItems() {
      showitemfield.value = true;
    }

    const headers = [
      {
        header: t("storetabdetails.prcreationtable.Category"),
        field: "ItemCategory1",
        class: "smallwidth newcolumnfreezeleft1",
      },
      {
        header: t("storetabdetails.prcreationtable.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.prcreationtable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",
      },
      {
        header: t("storetabdetails.prcreationtable.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        class: "newcolumnfreezeleft4",
      },
      {
        header: t("storetabdetails.prcreationtable.UOM"),
        field: "UOMName",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
      },
      {
        header: t("storetabdetails.prcreationtable.AvlQty"),
        // field: "StockInHand",
        slot: "StockInHand",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationtable.PickedQty"),
        field: "",
        slot: "PickedQty",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationtable.InTransist"),
        field: "",
        slot: "InTransist",
        fieldDisplay: "false",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "right_td",
        class: "smallwidth",
      },
      // {
      //   header: "Reorder Level",
      //   field: "ReOrderLevel",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      // {
      //   header: t('storetabdetails.prcreationtable.PackSizeName'),
      //   field: "PackSizename1",
      //   class: "smallwidth"
      // },
      // {
      //   header: t('storetabdetails.prcreationtable.PackSizeQty'),
      //   field: "PackSizeQty",
      //   bodyclass: "right_td",
      //   class: "smallwidth"
      // },
      {
        header: t("storetabdetails.prcreationtable.UnitRate"),
        field: "",
        bodyclass: "right_td",
        class: "smallwidth",
        fieldDisplay: "false",
        slot: "UnitRateSlot",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.prcreationtable.ReqQty"),
        field: "",
        bodyclass: "right_td",
        class: "smallwidth",
        fieldDisplay: "false",
        slot: "requested",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.prcreationtable.Rate"),
        field: "",
        bodyclass: "right_td",
        class: "smallwidth",
        fieldDisplay: "false",
        slot: "ratecal",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.prcreationtable.Description"),
        field: "Description",
        class: "smallwidth",
      },
      {
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
      },
    ];

    //ReOrder Level Table
    const ReOrderheaders = [
      {
        header: t("storetabdetails.prcreationreordertable.Category"),
        field: "ItemCategory1",
        class: "smallwidth newcolumnfreezeleft1",
      },
      {
        header: t("storetabdetails.prcreationreordertable.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.prcreationreordertable.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth newcolumnfreezeleft3",
      },
      {
        header: t("storetabdetails.prcreationreordertable.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        class: "newcolumnfreezeleft4",
      },
      {
        header: t("storetabdetails.prcreationreordertable.LPOSupplier"),
        field: "LPOSupplierName",
        bodyclass: "text_overflow2",

        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationreordertable.LPODate"),
        field: "LPODate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationreordertable.UOM"),
        field: "PurchaseUnitName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationreordertable.AvlQty"),
        field: "StockInHand",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationreordertable.Min"),
        field: "MinReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationreordertable.Max"),
        field: "MaxReOrderLevel",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationreordertable.Consumption"),
        field: "Consumption",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationreordertable.Reorder"),
        field: "ReOrderLevel",
        bodyclass: "right_td",

        class: "smallwidth",
      },
    ];

    const Iteminfoheaders = [
      {
        header: t("storetabdetails.prcreationiteminfoheaders.SupplierName"),
        field: "POSupplierName",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationiteminfoheaders.LastPurchaseDate"),
        field: "PurchaseDate",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationiteminfoheaders.Store"),
        field: "StoreName",
        class: "smallwidth",
      },

      {
        header: t("storetabdetails.prcreationiteminfoheaders.Qty"),
        field: "POQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationiteminfoheaders.UnitRate"),
        field: "UnitRate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.prcreationiteminfoheaders.Rate"),
        field: "Rate",
        bodyclass: "right_td",
        class: "smallwidth",
      },
    ];

    const paramValue = computed(() => {
      return route.query.param as string;
    });
    // let StoreId= route.query.
    const StockWOFileUpload = ref([]);

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      Name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
      },
      CreatedAt: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
      },
      Code: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
      length: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
      },
    };

    const handleValues = (valuesArray: string[]) => {
      debugger;
      AddData.value = valuesArray;
    };

    onMounted(() => {
      debugger;
      ReadyFuntion();
    });

    async function ReadyFuntion() {
      debugger;
      formloader.value = true;
      if (QueryStringValue3["StockWoTransTMId"] == "0" && param == "PR") {
        warningmsgcontent.value.TitleContent = "Raise a PR";
        warningmsgcontent.value.SubmitButtonName = "Send for PR";
        StoreDropdownDisable.value = false;
        await GetCode();
        LoadReOrderLevel();
      } else {
        ObjVal.value.DocNo = QueryStringValue3["DocNo"];
      }

      if (QueryStringValue3["StockWoTransTMId"] != "0" && param == "PR") {
        warningmsgcontent.value.TitleContent = "Raise a PR";
        warningmsgcontent.value.SubmitButtonName = "Update PR";
        StoreDropdownDisable.value = true;
        // LoadStores();
        await IsShowByStockTransId(QueryStringValue3["StockWoTransTMId"]);
        await LoadReOrderLevel();
      }
      formloader.value = false;
    }

    //Get Code
    async function GetCode() {
      debugger;
      let data = {
        EntityId: Entitydata.value,
        HospitalId: HospitalId,
        BranchId: QueryStringValue3["BranchId"],
        StoreId: StoreID ?? 0,
        // StoreId:
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      ObjVal.value.DocNo = result;
    }

    async function LoadStores() {
      try {
        debugger;

        let result = await StoreService.StoreDropDownListByUserId(
          session.UserId,
          session.OrganizationId,
          session.Admin,
          QueryStringValue3["BranchId"]
        );

        StoreDropdown.value.StoreOptions = result["result"]
          .filter((items) => items.HospitalId == session.OrganizationId)
          .map((item) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch { }
    }

    function StoreOnChange(ChangeValue) {
      debugger;
      if (ChangeValue == "S") {
        StoreDropdown.value.ToStoreId =
          StoreDropdown.value.StoreId?.Id ?? StoreDropdown.value.ToStoreId;

        StoreDropdown.value.ToStoreBrMapId =
          StoreDropdown.value.StoreId?.StoreBranchMapId ??
          StoreDropdown.value.ToStoreBrMapId;

        StoreDropdown.value.ToStoreBranchId =
          StoreDropdown.value.StoreId?.BranchId ??
          StoreDropdown.value.ToStoreBranchId;

        StoreDropdown.value.IsStoreSupplier = StoreDropdown.value.StoreId?.IsStoreSupplier ?
          StoreDropdown.value.StoreId?.IsStoreSupplier : false;
      }

      // Only call LoadRequestID if we're not in edit mode (StockWoTransTMId == "0")
      // This prevents the double call during edit mode
      if (
        StoreDropdown.value.ToStoreId != null &&
        StoreDropdown.value.ToStoreId != undefined &&
        StoreDropdown.value.ToStoreId != 0 &&
        StockWoTransTMId == "0" // Only call if not in edit mode
      ) {
        requestid.value.RequestIDOptions = [];
        requestid.value.RequestIDValue = "";
        // ItemTable.value = [];
        // items.value = [];
        LoadRequestID("N", "");
      }
    }

    const requestid = ref({
      RequestIDOptions: [],
      RequestIDValue: "",
    });
    let arr: any = [];

    // Load Request Id
    async function LoadRequestID(Status, value) {
      debugger;
      if (
        StoreDropdown.value.ToStoreId != null &&
        StoreDropdown.value.ToStoreId != 0
      ) {
        let PValues = ref({
          statusValue: Status == "N" ? "0,3,5" : "0,3,4,5",
          DocType: 1,
        });

        const result = await WithoutStockService.GetRequestIDs(
          StoreDropdown.value.ToStoreId,
          "FM",
          PValues.value.statusValue,
          PValues.value.DocType,
          StoreDropdown.value.ToStoreBrMapId
        );
        console.log(result);

        if (Status == "N") {
          requestid.value.RequestIDOptions = result["result"].map((item) => {
            item.name =
              item.DocNo +
              " / " +
              item.DocDateHR +
              " / " +
              item.CreatedByName +
              " / " +
              item.ItemCount;
            item.value = item.Id;
            return item;
          });
        } else {
          requestid.value.RequestIDOptions = result["result"]
            .map((item) => {
              item.name = item.DocNo + " / " + item.DocDateHR;
              item.value = item.Id;
              return item;
            })
            .filter(
              (item) =>
                (item.DocType == 1 && item.Status == 0) ||
                (item.DocType == 1 && item.Status == 5) ||
                (item.Status == 4 && value.includes(item.Id))
            );

          // Set RequestIDValue if we're in edit mode (Status == "E") and have a value
          if (Status == "E" && value != null && value != "") {
            requestid.value.RequestIDValue = value.split(",").map((i) => Number(i));
          }
        }

        console.log(requestid.value.RequestIDOptions);
      }
    }

    //Request Id OnChange
    async function RequestIDOnChange(requestId) {
      debugger;
      requestId = Array.isArray(requestId) ? requestId : [requestId];
      let nonExistingValues = requestId.filter(
        (item) => !SavingArray.value.includes(item)
      );
      RequestId = nonExistingValues.toString();
      console.log(RequestId);
      if (RequestId != "") {
        const result = await WithoutStockService.GetItemsByRequstIdForPIPR(
          RequestId
        );
        SavingArray.value = requestId;
        console.log(result["result"].length);
        Object.values(result["result"]).forEach((items: any) => {
          items.RequiredQuantity =
            Number(items.ReOrderLevel) - Number(items.StockInHand);
        });
        if (result["result"].length > 0) {
          for (let i = 0; i < result["result"].length; i++) {
            let obj = {};
            Object.assign(obj, result["result"][i]);
            console.log(obj);
            items.value.push(obj);
          }
          debugger;
          debugger;
          for (let i = 0; i < result["result"].length; i++) {
            let Index = ItemTable.value.findIndex(
              (ItemTableItems) =>
                ItemTableItems.ItemId === result["result"][i].ItemId &&
                ItemTableItems.Brand === result["result"][i].Brand &&
                ItemTableItems.ModelNumber ===
                result["result"][i].ModelNumber &&
                ItemTableItems.Size === result["result"][i].Size
            );
            if (Index !== -1) {
              ItemTable.value[Index].ItemQuantity =
                Number(ItemTable.value[Index].ItemQuantity) +
                Number(result["result"][i].ItemQuantity);
              ItemTable.value[Index].Rate = (
                ItemTable.value[Index].ItemQuantity *
                parseFloat(result["result"][i].UnitRate)
              ).toFixed(2);
              ItemTable.value[Index].MultipleReqId =
                ItemTable.value[Index].MultipleReqId +
                "," +
                String(result["result"][i].Id);
            } else {
              let obj: any = {};
              result["result"][i].UnitRate =
                result["result"][i].UnitRate.toFixed(2);
              result["result"][i].Rate = result["result"][i].Rate.toFixed(2);
              result["result"][i].IsEditFlag = false;
              Object.assign(obj, result["result"][i]);
              obj.MultipleReqId = String(result["result"][i].Id);
              console.log(obj);
              ItemTable.value.push(obj);
            }
          }
        }
      } else {
        debugger;
        debugger;
        let DeletedArray = items.value.filter((item) => {
          if (item.Id) {
            return item;
          }
        });
        DeletedArray = DeletedArray.filter(
          (item) => !requestId.includes(item.Id)
        );
        for (let i = 0; i < DeletedArray.length; i++) {
          let Index = ItemTable.value.findIndex(
            (ItemTableItems) =>
              ItemTableItems.ItemId === DeletedArray[i].ItemId &&
              ItemTableItems.Brand === DeletedArray[i].Brand &&
              ItemTableItems.ModelNumber === DeletedArray[i].ModelNumber &&
              ItemTableItems.Size === DeletedArray[i].Size
          );
          if (Index !== -1) {
            if (
              ItemTable.value[Index].ItemQuantity ==
              DeletedArray[i].ItemQuantity
            ) {
              if (ItemTable.value[Index]["StockDetailsId"]) {
                DeletedData.value.push(
                  ItemTable.value[Index]["StockDetailsId"]
                );
              }
              ItemTable.value.splice(Index, 1);
            } else {
              ItemTable.value[Index].ItemQuantity -= Number(
                DeletedArray[i].ItemQuantity
              );
              const stockIdToRemove = DeletedArray[i].Id.toString();
              // Use regex to remove the exact match (handles start, middle, and end cases)
              ItemTable.value[Index].MultipleReqId = ItemTable.value[
                Index
              ].MultipleReqId.replace(
                new RegExp(`(^|,)${stockIdToRemove}(,|$)`, "g"),
                "$1"
              ).replace(/(^,|,$)/g, ""); // Clean up any leading/trailing commas

              ItemTable.value[Index].Rate = (
                ItemTable.value[Index].ItemQuantity *
                parseFloat(ItemTable.value[Index].UnitRate)
              ).toFixed(2);
            }
          }
        }
        SavingArray.value = SavingArray.value.filter((item) =>
          requestId.includes(item)
        );
        items.value = items.value.filter((item) => {
          return !item.Id || requestId.includes(item.Id);
        });
      }
      if (ItemTable.value.length > 0 && IsDraftFlag == 1) {
        await IsSubmitDraft();
        if (DeletedData.value.length > 0) {
          let result = await WithoutStockService.DeleteList(
            DeletedData.value.join(",")
          );
        }
      }
    }
    const AddItems = async (value) => {
      debugger;
      console.log(value);

      if (value.length == 1) {
        // Check if item already exists in the table by exact match
        let Index = ItemTable.value.findIndex(
          (items) =>
            items.ItemId === value[0].ItemId &&
            items.Brand === value[0].Brand &&
            items.ModelNumber === value[0].ModelNumber &&
            items.Size === value[0].Size
        );

        if (Index !== -1) {
          // Item already exists, update quantity and rate
          ItemTable.value[Index].ItemQuantity =
            Number(ItemTable.value[Index].ItemQuantity) +
            Number(value[0].ItemQuantity);

          ItemTable.value[Index].Rate = (
            ItemTable.value[Index].ItemQuantity *
            parseFloat(ItemTable.value[Index].UnitRate)
          ).toFixed(2);
        } else {
          // Item doesn't exist, add it as new
          let newItem = { ...value[0] };
          newItem.IsEditFlag = false;

          // Ensure these values are properly initialized
          newItem.StockInHand = newItem.StockInHand || 0;
          newItem.PickedQty = newItem.PickedQty || 0;
          newItem.InTransist = newItem.InTransist || 0;

          ItemTable.value.push(newItem);

          // Don't add to items.value if it's already there
          let itemsIndex = items.value.findIndex(
            (item) =>
              item.ItemId === value[0].ItemId &&
              item.Brand === value[0].Brand &&
              item.ModelNumber === value[0].ModelNumber &&
              item.Size === value[0].Size
          );

          if (itemsIndex === -1) {
            items.value.push(newItem);
          }
        }
      } else if (ItemTable.value.length != 0) {
        let Index = ItemTable.value.findIndex(
          (items) => items.StockDetailsId == 0
        );
        if (Index != -1) {
          ItemTable.value[Index].IsEditFlag = false;

          // Ensure these values are properly initialized
          ItemTable.value[Index].StockInHand = ItemTable.value[Index].StockInHand || 0;
          ItemTable.value[Index].PickedQty = ItemTable.value[Index].PickedQty || 0;
          ItemTable.value[Index].InTransist = ItemTable.value[Index].InTransist || 0;

          // Check if this item is already in items.value
          let itemsIndex = items.value.findIndex(
            (item) =>
              item.ItemId === ItemTable.value[Index].ItemId &&
              item.Brand === ItemTable.value[Index].Brand &&
              item.ModelNumber === ItemTable.value[Index].ModelNumber &&
              item.Size === ItemTable.value[Index].Size
          );

          if (itemsIndex === -1) {
            items.value.push({ ...ItemTable.value[Index] });
          }
        }
      }

      if (IsDraftFlag == 1) {
        await IsSubmitDraft();
      }
    };

    watch(
      ItemTable,
      (newItems, oldItems) => {
        debugger;
        PRcalculation();
      },
      { deep: true }
    );

    const PRcalculation = () => {
      debugger;
      PRCalcDetailsClear();
      // for (let i = 0; i < items.value.length; i++) {
      //   PRCalcDetails.value.TotalAmount += Number(
      //     items.value[i]["ItemQuantity"] * items.value[i]["UnitRate"]
      //   ).toFixed(2);
      // }

      for (let i = 0; i < ItemTable.value.length; i++) {
        PRCalcDetails.value.GrossAmount += parseFloat(ItemTable.value[i]["Rate"]);
        PRCalcDetails.value.DiscountAmount += parseFloat(ItemTable.value[i]["DiscountAmount"] || 0);
        PRCalcDetails.value.TaxAmount += parseFloat(ItemTable.value[i]["Purchasetaxamount"] || 0);
        PRCalcDetails.value.SGSTTaxAmount += parseFloat(ItemTable.value[i]["SGSTTaxAmount"] || 0);
        PRCalcDetails.value.CGSTTaxAmount += parseFloat(ItemTable.value[i]["CGSTTaxAmount"] || 0);
        PRCalcDetails.value.IGSTTaxAmount += parseFloat(ItemTable.value[i]["IGSTTaxAmount"] || 0);
      }

      PRCalcDetails.value.GrossAmount = Number(PRCalcDetails.value.GrossAmount).toFixed(2);
      PRCalcDetails.value.DiscountAmount = Number(Number(ObjVal.value.DiscountAmount) + Number(PRCalcDetails.value.DiscountAmount)).toFixed(2);
      PRCalcDetails.value.TaxAmount = Number(PRCalcDetails.value.TaxAmount).toFixed(2);
      PRCalcDetails.value.SGSTTaxAmount = Number(PRCalcDetails.value.SGSTTaxAmount).toFixed(2);
      PRCalcDetails.value.CGSTTaxAmount = Number(PRCalcDetails.value.CGSTTaxAmount).toFixed(2);
      PRCalcDetails.value.IGSTTaxAmount = Number(PRCalcDetails.value.IGSTTaxAmount).toFixed(2);

      prSubcalculation();
    };

    const prSubcalculation = () => {
      debugger;
      if (ItemTable.value.length > 0) {
        PRCalcDetails.value.ItemCount = ItemTable.value.length;
      }
      PRCalcDetails.value.TotalAmount = ((Number(PRCalcDetails.value.GrossAmount) - Number(PRCalcDetails.value.DiscountAmount)) + (Number(PRCalcDetails.value.TaxAmount) + Number(PRCalcDetails.value.Transportcharges) + Number(PRCalcDetails.value.Freightcharges) + Number(PRCalcDetails.value.Othercharges))).toFixed(2)
    }

    function PRCalcDetailsClear() {
      debugger;
      PRCalcDetails.value.GrossAmount = 0.0;
      PRCalcDetails.value.DiscountAmount = 0.00;
      PRCalcDetails.value.TaxAmount = 0.00;
      PRCalcDetails.value.SGSTTaxAmount = 0.00;
      PRCalcDetails.value.CGSTTaxAmount = 0.00;
      PRCalcDetails.value.IGSTTaxAmount = 0.00;
      PRCalcDetails.value.ItemCount = 0;
      PRCalcDetails.value.TotalAmount = 0.00;
    }

    //Load Items by StockWoTrans Id
    async function IsShowByStockTransId(StockTransTMId) {
      debugger;
      const result = await WithoutStockService.GetByStockWOTransId(
        StockTransTMId
      );
      ItemTable.value = result["result"].map((item) => {
        item.UnitRate = Number(item.UnitRate).toFixed(2);
        item.Rate = Number(item.Rate).toFixed(2);
        item.Id = item.StockDetailsId;
        item.IsEditFlag = true;
        return item;
      });
      StoreDropdown.value.StoreId = result["result"][0]["ToStoreBrMapId"];
      ObjVal.value.StoreId = result["result"][0]["StoreId"];
      ObjVal.value.FromStore = result["result"][0]["FromStore"];
      StoreDropdown.value.ToStoreId = result["result"][0]["ToStore"];
      ObjVal.value.StoreBrMapId = result["result"][0]["StoreBrMapId"];
      ObjVal.value.FromStoreBrMapId = result["result"][0]["FromStoreBrMapId"];
      ObjVal.value.ToStoreBrMapId = result["result"][0]["ToStoreBrMapId"];
      ObjVal.value.Remarks = result["result"][0]["Remarks"];
      ObjVal.value.FromStoreBranchId = result["result"][0]["FromStoreBranchId"];
      StoreDropdown.value.ToStoreBrMapId =
        result["result"][0]["ToStoreBrMapId"];
      StoreDropdown.value.ToStoreBranchId =
        result["result"][0]["ToStoreBranchId"];

      StoreDropdown.value.IsStoreSupplier = result["result"][0]["IsStoreSupplier"];
      ObjVal.value.IsStoreSupplier = result["result"][0]["IsStoreSupplier"];

      LoadRequestID("E", result["result"][0]["RefNo"]);
      // The code to set requestid.value.RequestIDValue has been moved inside LoadRequestID function
      SavingArray.value = requestid.value.RequestIDValue;
      debugger;
      if (SavingArray.value.length != 0) {
        const Itemresult = await WithoutStockService.GetItemsByRequstIdForPIPR(
          SavingArray.value.toString()
        );
        Object.values(Itemresult["result"]).forEach((items: any) => {
          items.RequiredQuantity =
            Number(items.ReOrderLevel) - Number(items.StockInHand);
        });
        if (Itemresult["result"].length > 0) {
          for (let i = 0; i < Itemresult["result"].length; i++) {
            let Index = ItemTable.value.findIndex(
              (ItemTableItems) =>
                ItemTableItems.ItemId === Itemresult["result"][i].ItemId &&
                ItemTableItems.Brand === Itemresult["result"][i].Brand &&
                ItemTableItems.ModelNumber ===
                Itemresult["result"][i].ModelNumber &&
                ItemTableItems.Size === Itemresult["result"][i].Size
            );
            if (Index != -1) {
              let obj = {};
              Object.assign(obj, Itemresult["result"][i]);
              console.log(obj);
              items.value.push(obj);
            }
          }
        }
        if (ItemTable.value.length > 0) {
          for (let i = 0; i < ItemTable.value.length; i++) {
            let Index = items.value.findIndex(
              (ItemTableItems) =>
                ItemTableItems.ItemId === ItemTable.value[i].ItemId &&
                ItemTableItems.Brand === ItemTable.value[i].Brand &&
                ItemTableItems.ModelNumber === ItemTable.value[i].ModelNumber &&
                ItemTableItems.Size === ItemTable.value[i].Size
            );
            if (Index == -1) {
              let obj = {};
              Object.assign(obj, ItemTable.value[i]);
              obj["Id"] = 0;
              items.value.push(obj);
            } else {
              let totalQuantity = items.value
                .filter(
                  (ItemTableItems) =>
                    ItemTableItems.ItemId === ItemTable.value[i].ItemId &&
                    ItemTableItems.Brand === ItemTable.value[i].Brand &&
                    ItemTableItems.ModelNumber ===
                    ItemTable.value[i].ModelNumber &&
                    ItemTableItems.Size === ItemTable.value[i].Size
                )
                .reduce((sum, item) => sum + item.ItemQuantity, 0);
              if (totalQuantity < ItemTable.value[i].ItemQuantity) {
                let obj = {};
                Object.assign(obj, ItemTable.value[i]);
                obj["ItemQuantity"] =
                  Number(ItemTable.value[i].ItemQuantity) -
                  Number(totalQuantity);
                obj["Id"] = 0;
                items.value.push(obj);
              }
            }
          }
        }
      }
      RequestId = result["result"][0]["RefNo"];
      const FileUploadresult =
        await StockWOFileUploadServices.getStockWOFileById(StockTransTMId);
      if (FileUploadresult["result"].length > 0) {
        for (let i = 0; i < FileUploadresult["result"].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] =
            FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
            (Fileobj["fileName"] =
              FileUploadresult["result"][i].FileName.split("/").pop()),
            (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
            (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
            (Fileobj["Id"] = FileUploadresult["result"][i].Id),
            uploadedTableList.value.push(Fileobj);
        }
      }
    }

    //Item Edit
    function IsItemEdit(data) {
      debugger;
      dataItems.value = {};
      // alert(JSON.stringify(data))
      dataItems.value = data;
      dataItems.value["IsEdit"] = 1;
      displayClass.value = "show";
    }
    function clearItems(value1) {
      debugger;
      dataItems.value = {};
      // Object.assign(dataItems.value, value1);
    }
    function ItemUpdated(value1) {
      debugger;
      if (IsDraftFlag == 1) {
        IsSubmitDraft();
      }
    }

    let DeletedData: any = ref([]);

    const ItemDeleteConfirm = (event, data) => {
      confirm.require({
        target: event.currentTarget,
        message: "Do you want to delete this record?",
        icon: "pi pi-info-circle",
        rejectClass: "p-button-secondary p-button-outlined p-button-sm",
        acceptClass: "p-button-danger p-button-sm",
        rejectLabel: "Cancel",
        acceptLabel: "Delete",
        accept: () => {
          IsItemDelete(data);
        },
        reject: () => {
          toast.add({
            severity: "error",
            summary: "Rejected",
            detail: "You have rejected",
            life: 3000,
          });
        },
      });
    };

    //Item Delete for Item Table
    async function IsItemDelete(data) {
      debugger;
      let msg = null;
      if (ItemTable.value.length > 1) {
        if (data["StockDetailsId"] && data["StockDetailsId"] != 0) {
          DeletedData.value.push(data["StockDetailsId"]);
        }
        // if (DeletedData.value.length > 0 && IsDraftFlag == 1) {
        if (DeletedData.value.length > 0) {
          debugger;
          let result = await WithoutStockService.DeleteList(
            DeletedData.value.join(",")
          );
        }
        if (msg == null) {
          items.value = items.value.filter(
            (item) =>
              item["ItemId"] != data.ItemId ||
              (data.ModelNumber !== undefined &&
                item["ModelNumber"] !== data.ModelNumber) ||
              (data.Size !== undefined && item["Size"] !== data.Size) ||
              (data.Brand !== undefined && item["Brand"] !== data.Brand)
          );

          ItemTable.value = ItemTable.value.filter(
            (item) =>
              item["ItemId"] != data.ItemId ||
              (data.ModelNumber !== undefined &&
                item["ModelNumber"] !== data.ModelNumber) ||
              (data.Size !== undefined && item["Size"] !== data.Size) ||
              (data.Brand !== undefined && item["Brand"] !== data.Brand)
          );

          toast.add({
            severity: "info",
            summary: "Confirmed",
            detail: "Record deleted",
            life: 3000,
          });

          return;
        } else {
          toast.add({
            severity: "error",
            summary: "Error",
            detail: msg,
            life: 3000,
          });
          return;
        }
      } else {
        toast.add({
          severity: "info",
          summary: "Cannot Delete Last Item",
          detail: "You cannot delete the last remaining item.",
          life: 3000,
        });
        return;
      }
    }

    const IsDelete = async (data) => {
      // loading.value = true;

      try {
        debugger;
        let result: any;
        result = await WithoutStockService.deleteStockWoDetails(
          data.StockDetailsId
        );

        let message = result["ErrorInfo"].ErrorCode;
      } catch (error) {
        alert(error);
      }
    };
    function TotalGrossCalc(value1) {
      debugger;
      grossvalues.value.grossamount = value1.grossamount;
      grossvalues.value.totalqty = value1.totalqty;
      grossvalues.value.taxamount = value1.taxamount;
      grossvalues.value.totaldiscountamount = value1.totaldiscountamount;
      grossvalues.value.othercharges = value1.totalothercharges;
      grossvalues.value.transportcharges = value1.totaltransportcharges;
      grossvalues.value.servicecharges = value1.totalservicecharges;
      grossvalues.value.netamount = value1.netamount;
    }

    let fromStoreBranchMapId =
      Number(QueryStringValue3["storebranchmapid"]) ?? 0;
    let fromStoreId = Number(QueryStringValue3["StoreId"]) ?? 0;

    function calculatePacksNeeded(uom, uomPerMlPack, mlPackSize) {
      // Calculate total volume for the given number of packs
      // alert('s')
      debugger;
      const packSizeInMl = Math.ceil((uom / uomPerMlPack) * mlPackSize);
      return packSizeInMl;
    }

    function calculatePacksRate(uom, uomPerMlPack, mlPackSize, UnitRate) {
      // Calculate total volume for the given number of packs
      const packSizerate =
        Math.ceil((uom / uomPerMlPack) * mlPackSize) * UnitRate;
      // alert(packSizeInMl)
      return packSizerate.toFixed(2);
    }

    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      SaveLoader.value = true;
      var arr: any = [];
      let result: any = "";
      let PRid = 0;
      let message;
      var FileUploadArray: any = [];

      if (ItemTable.value.length == 0) {
        SaveLoader.value = false;
        toast.add({
          severity: "warn",
          summary: "Add the Items",
          detail: "Please add items to the purchase request before proceeding.",
          life: 3000,
        });
        return;
      } else {
        ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.BranchId = QueryStringValue3["BranchId"];
        ObjVal.value.HospitalId = HospitalId;
        ObjVal.value.ModifiedBy = UserId;
        ObjVal.value.CreatedBy = UserId;
        ObjVal.value.EntityId = Number(Entitydata.value);
        ObjVal.value.EntityOperationId = OperationId;
        ObjVal.value.DeptRoleId = rolesData.DeptRoleMapId;
        ObjVal.value.IsDraft = 0;
        ObjVal.value.DocType = "18";
        ObjVal.value.RefNo = requestid.value.RequestIDValue.toString();

        ObjVal.value.ToStore = StoreDropdown.value.ToStoreId;
        ObjVal.value.ToStoreBranchId = StoreDropdown.value.ToStoreBranchId;
        ObjVal.value.ToStoreBrMapId = StoreDropdown.value.ToStoreBrMapId;

        if (StockWoTransTMId != "0") {
          ObjVal.value.Id = StockWoTransTMId;
        }
        ObjVal.value.StoreId = StoreID;
        ObjVal.value.FromStore = StoreID;
        ObjVal.value.StoreBrMapId = fromStoreBranchMapId;
        ObjVal.value.FromStoreBranchId = QueryStringValue3["BranchId"];
        ObjVal.value.FromStoreBrMapId = fromStoreBranchMapId;

        if (StockWoTransTMId == "0") {
          ObjVal.value.IsStoreSupplier = StoreDropdown.value.IsStoreSupplier ?
            StoreDropdown.value.IsStoreSupplier
            : false;
        } else {
          ObjVal.value.IsStoreSupplier = ObjVal.value.IsStoreSupplier ?
            ObjVal.value.IsStoreSupplier
            : false;
        }

        ObjVal.value.TaxAmount = PRCalcDetails.value.TaxAmount
        ObjVal.value.SGSTTaxAmount = PRCalcDetails.value.SGSTTaxAmount
        ObjVal.value.CGSTTaxAmount = PRCalcDetails.value.CGSTTaxAmount
        ObjVal.value.IGSTTaxAmount = PRCalcDetails.value.IGSTTaxAmount
        ObjVal.value.Amount = PRCalcDetails.value.TotalAmount;

        let id: any = 0;
        if (ParameterValues.value.Id) {
          ObjVal.value.Id = ParameterValues.value.Id;
        }
        debugger;
        for (let i = 0; i < ItemTable.value.length; i++) {
          let obj = {};
          (obj["Id"] = ItemTable.value[i].IsEditFlag
            ? ItemTable.value[i]["StockDetailsId"] || 0
            : 0),
            (obj["RequestId"] = ItemTable.value[i]["Id"] || 0),
            (obj["ItemId"] = ItemTable.value[i]["ItemId"]),
            (obj["Qty"] = ItemTable.value[i]["ItemQuantity"]),
            (obj["RefId"] = PRid),
            (obj["PackSizeId"] = ItemTable.value[i]["PackSizeId"]),
            (obj["UOM"] = ItemTable.value[i]["UOM"]),
            (obj["HSNId"] = ItemTable.value[i]["HSNId"]),
            (obj["UnitRate"] = ItemTable.value[i]["UnitRate"]),
            (obj["Rate"] = ItemTable.value[i]["Rate"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),

            (obj["Brand"] =
              ItemTable.value[i]["Brand"] == null
                ? 0
                : ItemTable.value[i]["Brand"]),
            (obj["ModelNumber"] =
              ItemTable.value[i]["ModelNumber"] == null
                ? 0
                : ItemTable.value[i]["ModelNumber"]),
            (obj["Size"] =
              ItemTable.value[i]["Size"] == null
                ? 0
                : ItemTable.value[i]["Size"]);

          (obj["Description"] = ItemTable.value[i]["Description"]);

          (obj["MultipleReqId"] = ItemTable.value[i]["MultipleReqId"]);

          (obj["DiscountPer"] = ItemTable.value[i]["Discount"] || 0),
            (obj["DiscountAmount"] = ItemTable.value[i]["DiscountAmount"] || 0),
            (obj["PurchaseTax"] = ItemTable.value[i]["PurchasePercentage"] || 0),
            (obj["PurchaseTaxAmount"] = ItemTable.value[i]["Purchasetaxamount"] || 0),
            (obj["SGSTTax"] = ItemTable.value[i]["SGSTTax"] || 0),
            (obj["SGSTTaxAmount"] = ItemTable.value[i]["SGSTTaxAmount"] || 0),
            (obj["CGSTTax"] = ItemTable.value[i]["CGSTTax"] || 0),
            (obj["CGSTTaxAmount"] = ItemTable.value[i]["CGSTTaxAmount"] || 0),
            (obj["IGSTTax"] = ItemTable.value[i]["IGSTTax"] || 0),
            (obj["IGSTTaxAmount"] = ItemTable.value[i]["IGSTTaxAmount"] || 0),
            (obj["Amount"] = ItemTable.value[i]["Totalvalue"] || 0),

            arr[i] = obj;
        }
        ObjVal.value.StockWODetailList = arr;
        let result = await WithoutStockService.createStockWODraft(ObjVal.value);
        id = result["result"][0].Id;
        ObjVal.value.Id = id;
        for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0];
          ItemTable.value[ItemTable.value.length - 1].Id =
            ResultList.StockWODetailList[0]["Id"];
          ItemTable.value[ItemTable.value.length - 1].StockDetailsId =
            ResultList.StockWODetailList[0]["Id"];
        }
        loading.value = false;
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = ObjVal.value.DocType),
              (Fileobj["RefId"] = ObjVal.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(Entitydata.value)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj);
          }
          StockWOFileUpload.value = FileUploadArray;
          let FileUploadResult =
            await StockWOFileUploadServices.insertStockWOFile(
              StockWOFileUpload.value
            );
        }
        if (DeletedFileUpload.length > 0) {
          debugger;
          let result = await StockWOFileUploadServices.DeleteList(
            DeletedFileUpload.join(",")
          );
        }
      }
      if (StockWoTransTMId != 0) {
        SaveLoader.value = false;
        updatepop.value = true;
      } else {
        SaveLoader.value = false;
        PrintCrystalReport(PRid);
        successpop.value = true;
      }
    });

    const IsSubmitDraft = handleSubmit(async (values) => {
      debugger;
      var arr: any = [];
      loading.value = true;
      var FileUploadArray: any = [];

      let PRid = 0;
      if (ItemTable.value.length > 0) {
        console.log(ObjVal.value);
        ObjVal.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.ModifiedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.HospitalId = HospitalId;
        ObjVal.value.ModifiedBy = UserId;
        ObjVal.value.CreatedBy = UserId;
        ObjVal.value.EntityId = Number(Entitydata.value);
        ObjVal.value.DocDate = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
        ObjVal.value.BranchId = QueryStringValue3["BranchId"];
        ObjVal.value.DocType = "18";
        ObjVal.value.RefNo = requestid.value.RequestIDValue.toString();

        ObjVal.value.EntityOperationId = OperationId;
        ObjVal.value.DeptRoleId = rolesData.DeptRoleMapId;
        ObjVal.value.StoreId = StoreID;
        ObjVal.value.FromStore = StoreID;
        ObjVal.value.ToStore = StoreDropdown.value.ToStoreId;
        ObjVal.value.StoreBrMapId = fromStoreBranchMapId;
        ObjVal.value.FromStoreBranchId = QueryStringValue3["BranchId"];
        ObjVal.value.FromStoreBrMapId = fromStoreBranchMapId;
        ObjVal.value.ToStoreBrMapId = StoreDropdown.value.ToStoreBrMapId;
        ObjVal.value.ToStoreBranchId = StoreDropdown.value.ToStoreBranchId;
        ObjVal.value.IsDraft = 1;

        if (StockWoTransTMId == "0") {
          ObjVal.value.IsStoreSupplier = StoreDropdown.value.IsStoreSupplier ?
            StoreDropdown.value.IsStoreSupplier
            : false;
        } else {
          ObjVal.value.IsStoreSupplier = ObjVal.value.IsStoreSupplier ?
            ObjVal.value.IsStoreSupplier
            : false;
        }

        ObjVal.value.TaxAmount = PRCalcDetails.value.TaxAmount
        ObjVal.value.SGSTTaxAmount = PRCalcDetails.value.SGSTTaxAmount
        ObjVal.value.CGSTTaxAmount = PRCalcDetails.value.CGSTTaxAmount
        ObjVal.value.IGSTTaxAmount = PRCalcDetails.value.IGSTTaxAmount
        ObjVal.value.Amount = PRCalcDetails.value.TotalAmount;

        let id: any = 0;
        if (StockWoTransTMId != "0") {
          ObjVal.value.Id = StockWoTransTMId;
        }
        debugger;
        for (let i = 0; i < ItemTable.value.length; i++) {
          let obj = {};
          (obj["Id"] = ItemTable.value[i].IsEditFlag
            ? ItemTable.value[i]["StockDetailsId"] || 0
            : 0),
            (obj["RequestId"] = ItemTable.value[i]["Id"] || 0),
            (obj["ItemId"] = ItemTable.value[i]["ItemId"]),
            (obj["Qty"] = ItemTable.value[i]["ItemQuantity"]),
            (obj["RefId"] = PRid),
            (obj["PackSizeId"] = ItemTable.value[i]["PackSizeId"]),
            (obj["UOM"] = ItemTable.value[i]["UOM"]),
            (obj["HSNId"] = ItemTable.value[i]["HSNId"]),
            (obj["UnitRate"] = ItemTable.value[i]["UnitRate"]),
            (obj["Rate"] = ItemTable.value[i]["Rate"]),
            (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
            (obj["CreatedBy"] = UserId),
            (obj["ModifiedBy"] = UserId),

            (obj["Brand"] =
              ItemTable.value[i]["Brand"] == null
                ? 0
                : ItemTable.value[i]["Brand"]),
            (obj["ModelNumber"] =
              ItemTable.value[i]["ModelNumber"] == null
                ? 0
                : ItemTable.value[i]["ModelNumber"]),
            (obj["Size"] =
              ItemTable.value[i]["Size"] == null
                ? 0
                : ItemTable.value[i]["Size"]);

          (obj["Description"] = ItemTable.value[i]["Description"]);

          (obj["MultipleReqId"] = ItemTable.value[i]["MultipleReqId"]);

          (obj["DiscountPer"] = ItemTable.value[i]["Discount"] || 0),
            (obj["DiscountAmount"] = ItemTable.value[i]["DiscountAmount"] || 0),
            (obj["PurchaseTax"] = ItemTable.value[i]["PurchasePercentage"] || 0),
            (obj["PurchaseTaxAmount"] = ItemTable.value[i]["Purchasetaxamount"] || 0),
            (obj["SGSTTax"] = ItemTable.value[i]["SGSTTax"] || 0),
            (obj["SGSTTaxAmount"] = ItemTable.value[i]["SGSTTaxAmount"] || 0),
            (obj["CGSTTax"] = ItemTable.value[i]["CGSTTax"] || 0),
            (obj["CGSTTaxAmount"] = ItemTable.value[i]["CGSTTaxAmount"] || 0),
            (obj["IGSTTax"] = ItemTable.value[i]["IGSTTax"] || 0),
            (obj["IGSTTaxAmount"] = ItemTable.value[i]["IGSTTaxAmount"] || 0),
            (obj["Amount"] = ItemTable.value[i]["Totalvalue"] || 0),

            arr[i] = obj;
        }
        ObjVal.value.StockWODetailList = arr;
        let result = await WithoutStockService.createStockWODraft(ObjVal.value);
        id = result["result"][0].Id;
        ObjVal.value.Id = id;
        for (let i = 0; i < ObjVal.value.StockWODetailList.length; i++) {
          const ResultList = result["result"][0];
          ItemTable.value[i].Id = ResultList.StockWODetailList[i]["Id"];
          ItemTable.value[i].StockDetailsId =
            ResultList.StockWODetailList[i]["Id"];
          ItemTable.value[i].IsEditFlag = true;
        }
        if (uploadedTableList.value.length != 0) {
          for (let i = 0; i < uploadedTableList.value.length; i++) {
            let Fileobj = {};
            (Fileobj["Id"] = uploadedTableList.value[i].Id),
              (Fileobj["DocType"] = ObjVal.value.DocType),
              (Fileobj["RefId"] = ObjVal.value.Id),
              (Fileobj["FileName"] = uploadedTableList.value[i].fileName),
              (Fileobj["CreatedAt"] = moment().format(
                "YYYY-MM-DDTHH:mm:ss.SSSZ"
              )),
              (Fileobj["CreatedBy"] = UserId),
              (Fileobj["ModifiedBy"] = 0),
              (Fileobj["EntityId"] = Number(Entitydata.value)),
              (Fileobj["IsApproved"] = 0),
              FileUploadArray.push(Fileobj);
          }
          StockWOFileUpload.value = FileUploadArray;
          // let FileUploadResult =
          //   await StockWOFileUploadServices.insertStockWOFile(
          //     StockWOFileUpload.value
          //   );
        }
        loading.value = false;
      } else {
        toast.add({
          severity: "warn",
          summary: "Add the Items",
          detail: "Please add items to the purchase request before proceeding.",
          life: 3000,
        });
      }
    });

    //ReOrder Level Table
    async function LoadReOrderLevel() {
      debugger;

      let result = await WithoutStockService.GetReOrderLevelList(
        StoreID,
        HospitalId,
        BranchId
      );
      console.log(result);
      result = result["result"];

      ReOrderData.value = result;
    }

    function ReOrderItemSelect(value) {
      debugger;

      selectedProduct.value = value;

      console.log(selectedProduct.value);
    }

    function AddSingleConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = "There is no Items.";
        wariningPopup.value = true;
      } else if (selectedProduct.value == "" || selectedProduct.value == null) {
        warningmsgcontent.value.warningcontent = "Please Select the Items.";
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          "Do you want to add selected items to request ?";
        AddItemmodel.value = true;
      }
    }

    function AddAllConfirmation(val) {
      debugger;
      confirmval.value = val;
      if (ReOrderData.value == "") {
        warningmsgcontent.value.warningcontent = "There is no Items.";
        wariningPopup.value = true;
      } else {
        msgcontent.value.contentvalue =
          "Do you want to add all items to request ?";
        AddItemmodel.value = true;
      }
    }

    function ClosewariningPopup() {
      debugger;
      wariningPopup.value = false;
    }

    let CopiedReOrderData: any = ref([]);
    let RemoveReOrderItems: any = ref([]);

    async function CopyReorderData() {
      debugger;

      if (ItemTable.value.length > 0) {
        Object.values(ItemTable.value).forEach((x: any) => {
          Object.values(selectedProduct.value).forEach((y: any) => {
            if (y.ReOrderLevel != 0) {
              if (
                x.ItemId == y.ItemId &&
                x.Brand == y.Brand &&
                x.ModelNumber == y.ModelNumber &&
                x.Size == y.Size
              ) {
                x.UOM = y.UOM;
                x.UOMName = y.UOMName;
                x.PackSizeId = y.PackSizeId;
                x.PackSizename1 = y.PackSizename1;
                x.PackSizeQty = y.PackSizeQty;
                x.ItemQuantity = x.ItemQuantity + y.ReOrderLevel;
                x.UnitRate = Number(y.UnitRate).toFixed(2);
                x.Rate = Number(x.ItemQuantity * y.UnitRate).toFixed(2);
                RemoveReOrderItems.value.push(y);
              } else {
                const existingItem = CopiedReOrderData.value.find(
                  (item: any) =>
                    item.ItemId === y.ItemId &&
                    item.Brand === y.Brand &&
                    item.ModelNumber === y.ModelNumber &&
                    item.Size === y.Size
                );

                if (!existingItem) {
                  CopiedReOrderData.value.push(y);
                  RemoveReOrderItems.value.push(y);
                }
              }
            }
          });
        });

        if (CopiedReOrderData.value.length > 0) {
          const mappedItems = CopiedReOrderData.value.map((item) => {
            item.UOM = item.PurchaseUnit;
            item.UOMName = item.PurchaseUnitName;
            item.ItemQuantity = item.ItemQuantity + item.ReOrderLevel;
            item.UnitRate = Number(item.UnitRate).toFixed(2);
            item.Rate = Number(item.ItemQuantity * item.UnitRate).toFixed(2);

            // Ensure these values are properly initialized
            item.StockInHand = item.StockInHand || 0;
            item.PickedQty = item.PickedQty || 0;
            item.InTransist = item.InTransist || 0;

            return item;
          });
          // Push each mapped item to ItemTable.value
          mappedItems.forEach((item) => {
            ItemTable.value.push(item);
          });
        }
      } else {
        Object.values(selectedProduct.value).forEach((y: any) => {
          if (y.ReOrderLevel != 0) {
            CopiedReOrderData.value.push(y);
            RemoveReOrderItems.value.push(y);
          }
        });

        if (CopiedReOrderData.value.length > 0) {
          const mappedItems = CopiedReOrderData.value.map((item) => {
            item.UOM = item.PurchaseUnit;
            item.UOMName = item.PurchaseUnitName;
            item.ItemQuantity = item.ItemQuantity + item.ReOrderLevel;
            item.UnitRate = Number(item.UnitRate).toFixed(2);
            item.Rate = Number(item.ItemQuantity * item.UnitRate).toFixed(2);
            return item;
          });
          mappedItems.forEach((item) => {
            ItemTable.value.push(item);
          });
        }
      }

      if (RemoveReOrderItems.value.length > 0) {
        ReOrderData.value = ReOrderData.value.filter((x: any) => {
          return !Object.values(RemoveReOrderItems.value).some((y: any) => {
            return (
              x.ItemId === y.ItemId &&
              x.Brand === y.Brand &&
              x.ModelNumber === y.ModelNumber &&
              x.Size === y.Size
            );
          });
        });
      }

      const hasZeroQuantity = selectedProduct.value.some(
        (item) => item.ReOrderLevel === 0
      );

      // Don't set items.value = ItemTable.value as this can cause duplicates
      // Instead, ensure items.value contains all items from ItemTable.value without duplicates
      items.value = [];
      ItemTable.value.forEach(item => {
        items.value.push({ ...item });
      });
      CopiedReOrderData.value = [];
      RemoveReOrderItems.value = [];
      selectedProduct.value = [];
      AddItemmodel.value = false;

      if (hasZeroQuantity) {
        toast.add({
          severity: "warn",
          summary: "Item Quantity Error",
          detail:
            "One or more items have a quantity of 0. Please check the items.",
          life: 3000,
        });
        return;
      } else {
        // Call IsSubmitDraft if IsDraftFlag is 1, similar to AddItems function
        if (IsDraftFlag == 1) {
          await IsSubmitDraft();
        }
        clases.value.ItemsReOrderTab = 0;
      }
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      setupHistoryManagement(router, 2);
    }

    function AddButtonItem() {
      if (!StoreDropdown.value.StoreId) {
        toast.add({
          severity: "info",
          summary: "Choose Store",
          detail: "Please select a store before proceeding.",
          life: 3000,
        });
      } else {
        toggleshow.value = !toggleshow.value;
      }
    }
    function PrintCrystalReport(Id) {
      debugger;
      CrystalReportPopup.value = false;
      ParameterValues.value.Id = Id;
    }

    let fullPath = ref();
    let uploadedfilelist: any = ref();
    let uploadedTableList: any = ref([]);

    const handleChangedocument = async (event: Event) => {
      debugger;
      let result;
      let files: any = "";
      const input = event.target as HTMLInputElement;
      files = input["files"];
      console.log(files);

      if (files && files.length > 0) {
        debugger;
        for (let i = 0; i < files.length; i++) {
          let form = new FormData();
          console.log(files[i]);
          form.append("file", files[i]);
          console.log(form);
          result = await common.uploadquotation(form, "TransactionFiles");
          console.log("Uploaded :", result);
          let ResponseValue = result; //
          fullPath.value = result.uploadPath;
          uploadedTableList.value.push(ResponseValue);
        }
      }
      console.log(uploadedTableList.value);
    };
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }

    function passStatus() {
      if (QueryStringValue.status == "1") {
        return 7;
      } else if (QueryStringValue.status == "2") {
        return 6;
      } else if (QueryStringValue.status == "3") {
        return 0;
      }
    }

    async function getSupplierDetailsItemId(data) {
      debugger;
      try {
        const result = await WithoutStockService.GetSupplierDetailsByItemId(
          data.ItemId,
          data.Brand,
          data.ModelNumber,
          data.Size,
          data.UOM
        );
        supplierDetailsList.value = result["result"];
      } catch (error) {
        console.log(error);
      }
    }
    let DeletedFileUpload: any = [];
    const fileuploadDelete = async (data) => {
      DeletedFileUpload.push(data.Id);
      uploadedTableList.value = uploadedTableList.value.filter(
        (item) => item.fileName != data.fileName
      );
      if (DeletedFileUpload.length > 0 && IsDraftFlag == 1) {
        debugger;
        let result = await StockWOFileUploadServices.DeleteList(
          DeletedFileUpload.join(",")
        );
      }
    };

    return {
      clearItems,
      ItemUpdated,
      handleChangedocument,
      uploadedTableList,
      fileuploadDelete,
      Iteminfoheaders,
      visible,
      supplierDetailsList,
      getSupplierDetailsItemId,
      StoreID,
      calculatePacksRate,
      calculatePacksNeeded,
      QueryStringValue,
      passStatus,
      showitemfield,
      ShowItems,
      globalFilterFields,
      filters,
      items,
      headers,
      loading,
      paramValue,
      requestid,
      GetCode,
      handleValues,
      AddItems,
      List,
      RequestIDOnChange,
      LoadRequestID,
      ObjVal,
      IsSubmit,
      showFields,
      IsItemEdit,
      IsItemDelete,
      dataItems,
      commonItemProps,
      IsShowByStockTransId,
      closetrigger,
      successpop,
      updatepop,
      ReOrderData,
      ReOrderheaders,
      LoadReOrderLevel,
      selectedProduct,
      ReadyFuntion,
      CopyReorderData,
      AddItemmodel,
      wariningPopup,
      ClosewariningPopup,
      AddSingleConfirmation,
      AddAllConfirmation,
      msgcontent,
      warningmsgcontent,
      confirmval,
      TotalGrossCalc,
      displayClass,
      clases,
      requestdropdown,
      requestValue,
      requestidValue,
      requestdata,
      StoreDropdown,
      StoreOnChange,
      ItemTable,
      param,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      StoreDropdownDisable,
      // uploadquotation,
      FileObject,
      fileviewer,
      StoreStatus,
      ReOrderItemSelect,
      SavingArray,
      AddButtonItem,
      toggleshow,
      StockWoTransTMId,
      SaveLoader,
      ItemDeleteConfirm,
      formloader,
    };
  },
});
</script>

<style lang="scss">
@import "../../../../../assets/variables.scss";
@import "../../../../../assets/main.scss";

.requestlabel {
  display: block !important;
}

#file-name {
  width: 40px;
}

.flbtn {
  width: auto !important;
  background-color: blue;
  padding: 10px 20px;
  border-radius: 5px;
  color: white !important;
  cursor: pointer;

  i {
    color: white !important;
    padding-right: 2px;
  }
}

.fileuploadcard {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #e1e1e1;
  border-radius: 5px;
  background-color: #fff;
  // min-width: -webkit-fill-available;
  flex: 1;
}

.filenametxt {
  // text-overflow: ellipsis;

  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.filename {
  @include custom-text($txtcolor, 12px, 500);
}
</style>
